import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./EventModal.css";
import ScheduleModal from "./ScheduleModal";
import EventEdit from "./EventEdit";
import AlertModal from "./AlertModal";
import MoveEvents from "../modals/MoveEvents";
import AdjustDurationDialog from "./AdjustDurationDialog";
import HTMLReader from "./HTMLReader";

import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { movedToNextDayMessage } from "../../Common/dayOverflow";

const EventModal = (props) => {
  const [scheduleModal, setScheduleModal] = useState(false);
  const [ShowEventEdit, setShowEventEdit] = useState(false);
  const [EventEditMode, setShowEventMode] = useState("MODIFY");
  const [EventEditWhere, setShowEventWhere] = useState("after");
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [AlertModalVideoKey, setAlertModalVideoKey] = useState(undefined);
  const [Mode, setMode] = useState("shift_events");
  const [ParamDate, setParamDate] = useState(null);
  const [MoveEventsShow, setMoveEventsShow] = useState(false);
  const [AdjustDurationShow, setAdjustDurationShow] = useState(false);
  const [HTMLReaderShow, setHTMLReaderShow] = useState(false);
  const [HTMLReaderContent, setHTMLReaderContent] = useState("");

  const dispatch = useDispatch();
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let ScheduleNames = useSelector((state) => state.ScheduleNames);

  let event = useSelector((state) => state.SelectedEvent);
  let MobileMode = useSelector((state) => state.MobileMode);
  let CurrentAppScreen = useSelector((state) => state.CurrentAppScreen);
  let GuideEditMode = useSelector((state) => state.GuideEditMode);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let user_info = useSelector((state) => state.user_info);
  const advancedMode = user_info?.advanced_mode === "On";

  function eventContainsPlaces() {
    if (event == null) return true;
    return event.get_places(window.guide_obj.places).length > 0;
  }

  function handleShowOnMap() {
    const places = event.get_places(window.guide_obj.places);
    if (places.length === 0) {
      myAlert("No places in event", "Info");
      props.onHide();
      return;
    }
    //if (places.length === 1) {
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.setShowHiddenPlace({ value: places }));
    dispatch(slice1Actions.centerMapToPlaces({ value: places }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    //dispatch(slice1Actions.setMapCenterPlace({ place: places[0] }));
    // } else {
    //   dispatch(slice1Actions.ClearAllFilters());
    //   if (places.length > 0) dispatch(slice1Actions.SetPlacesFilter({ value: places }));
    //   dispatch(slice1Actions.setGuide({ guide: null }));
    // }
    if (MobileMode) {
      // This never actually did anything visible in mobile mode before —
      // #map-start only scrolls to something already on screen, which Map
      // isn't unless CurrentAppScreen is already "Map". Same fix as
      // PlaceModal.js's handleCenterInMap: switch screens for real, and
      // record where we came from so PlacesHeader.js's back arrow can
      // return here. Found/fixed 2026-09-09.
      dispatch(slice1Actions.pushAppScreen({ value: CurrentAppScreen }));
      dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
    } else {
      window.location.href = "#map-start";
    }
    props.onHide();
  }

  function FilterPlaces() {
    const places = event.get_places(window.guide_obj.places);
    if (places.length === 0) {
      myAlert("No places in event", "Info");
      props.onHide();
      return;
    }
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.setShowHiddenPlace({ value: places }));
    dispatch(slice1Actions.SetPlacesFilter({ value: places }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    window.location.href = "#map-start";
    props.onHide();
  }

  function handleShowDetails() {
    const htmlString = event.createHTML(window.guide_obj.places);

    if (MobileMode) {
      // Was hijacking Home's own content (setHTMLToSHow +
      // setCurrentAppScreen("Home")), stranding the user there instead of
      // returning to Schedule on back — see PlaceModal.js's
      // handleShowPlaceAttributes for the same class of bug. Shown in a
      // local dialog instead, mirroring PlaceModal.js/PlaceCard.js's own
      // HTMLReader dialog pattern. Fixed 2026-09-13.
      setHTMLReaderContent(htmlString);
      setHTMLReaderShow(true);
      return;
    }
    dispatch(slice1Actions.setHTMLTitle({ value: "Event Details" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    window.location.href = "#home-start";
    var homeDiv = document.getElementById("home-content-start");
    homeDiv.scrollIntoView();
    props.onHide();
  }

  function handleEditEvent() {
    setShowEventMode("MODIFY");
    setShowEventWhere("after");
    setShowEventEdit(true);
    props.onHide();
  }

  function handleSwapEvent() {
    props.onSwapEvent(event);
  }

  function handleAdjustDuration() {
    setAdjustDurationShow(true);
  }

  // Events chronologically after this one (by original Start), scoped to
  // just this event's calendar day or the whole itinerary. Used by
  // Grow/Shrink (shift them) and by the "Leave As-Is" overlap check
  // (inspect just the immediate next one).
  function getLaterEvents(scope) {
    const dayISO = DateTime.fromISO(event.Start, { zone: "utc" }).toISODate();
    const allEvents = window.guide_obj.schedule.getEventsToDisplay(ScheduleName);
    const idx = allEvents.findIndex((e) => e.value.ID === event.ID);
    if (idx < 0) return [];
    let later = allEvents.slice(idx + 1).map((e) => e.value);
    if (scope === "day")
      later = later.filter((e) => DateTime.fromISO(e.Start, { zone: "utc" }).toISODate() === dayISO);
    return later;
  }

  function confirmAdjustDuration({ minutes, mode, scope }) {
    const dayISO = DateTime.fromISO(event.Start, { zone: "utc" }).toISODate();
    const startTime = DateTime.fromISO(event.Start, { zone: "utc" });
    const originalMinutes = DateTime.fromISO(event.End, { zone: "utc" }).diff(startTime, "minutes").minutes;
    const newEnd = startTime.plus({ minutes });

    const modifiedEvent = { ...event, End: newEnd.toISO() };
    window.guide_obj.schedule.modifyEvent(modifiedEvent);

    // Feed the correction back into the place itself (not just this one
    // event) so future auto-builds start from it — only when unambiguous
    // (exactly one place on the event).
    const places = event.get_places(window.guide_obj.places);
    if (places.length === 1) { places[0].Duration = minutes; delete places[0].DurationUnset; }

    if (mode === "recalculate") {
      const dayStart = GuideSettings.schedule_day_start ?? 9;
      const dayEnd = GuideSettings.schedule_day_end ?? 20;
      if (scope === "day") {
        const result = window.guide_obj.schedule.recalculateDay(
          dayISO, ScheduleName, user_info.event_time_rounding, user_info.default_duration,
          window.guide_obj.places, false, dayStart, true, true, 1, dayEnd
        );
        // This dialog closes right after, so the browser's own alert says
        // which stops went to the next day.
        const moved = movedToNextDayMessage(result?.movedToNextDay);
        if (moved) setTimeout(() => window.alert(`${moved.title}\n\n${moved.body}`), 0);
      } else {
        window.guide_obj.schedule.recalculateSchedule(
          ScheduleName, user_info.event_time_rounding, user_info.default_duration,
          window.guide_obj.places, false, dayStart, dayEnd, true, true
        );
      }
      // A recalculate just resolved whatever conflict prompted the banner
      // (if it was showing for this day).
      dispatch(slice1Actions.setDayConflictBanner({ value: null }));
    } else if (mode === "growShrink") {
      // Move every later event by exactly the same amount this one changed
      // by — a 30min shrink moves them all 30min earlier, an overlap from
      // growing pushes them all later by the same amount. Their own
      // Start-to-End durations (and any place-duration knowledge behind
      // them) are untouched, unlike a full recalculate.
      const delta = minutes - originalMinutes;
      if (delta !== 0) {
        getLaterEvents(scope).forEach((e) => {
          const shiftedStart = DateTime.fromISO(e.Start, { zone: "utc" }).plus({ minutes: delta });
          const shiftedEnd = DateTime.fromISO(e.End, { zone: "utc" }).plus({ minutes: delta });
          window.guide_obj.schedule.modifyEvent({ ...e, Start: shiftedStart.toISO(), End: shiftedEnd.toISO() });
        });
      }
      dispatch(slice1Actions.setDayConflictBanner({ value: null }));
    } else {
      const nextEvent = getLaterEvents("day")[0];
      const overlaps = nextEvent && newEnd > DateTime.fromISO(nextEvent.Start, { zone: "utc" });
      if (overlaps) dispatch(slice1Actions.setDayConflictBanner({ value: dayISO }));
    }

    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  }

  function handleDeleteEvent() {
    myConfirm("This will delete the event. Continue?", [
      { Title: "OK", Method: () => _handleDeleteEvent() },
      { Title: "CANCEL", Method: null },
    ]);
    props.onHide();
  }

  const myConfirm = (message, buttons) => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };

  function _handleDeleteEvent() {
    window.guide_obj.schedule.deleteEvent(event);
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  }

  function handleAddEventA() {
    setShowEventMode("ADD");
    setShowEventWhere("after");
    setShowEventEdit(true);
    props.onHide();
  }

  function handleAddEventB() {
    setShowEventMode("ADD");
    setShowEventWhere("before");
    setShowEventEdit(true);
    props.onHide();
  }

  const EventEditCallback = () => {
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const myAlert = (message, title, buttons, videoKey) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Message" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalVideoKey(videoKey);
    setAlertModalShow(true);
  };

  // const combineEventBefore = () => {
  //   window.guide_obj.schedule.combineWithPreviousEvent(this._event, ScheduleName);
  //   this.props.onGetScheduleToDisplay(this.props.guide_id);
  // };

  const combineEvents = (action) => {
    let items = window.guide_obj.schedule.getEventsToDisplay(ScheduleName);
    dispatch(slice1Actions.setMultiselectCallback({ value: combineEventsCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: items }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: [] }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Events" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const combineEventsCallBack = (events) => {
    if (events.length === 0) return;
    console.log("combineEventsCallBack", events);
    window.guide_obj.schedule.combineWithEvents(event, events);
    dispatch(slice1Actions.setGuide({ guide: null }));
    updateMainScheduleAndDoc();
  };

  const updateMainScheduleAndDoc = () => {
    myAlert("Update Main Schedule and Itinerary with these changes?", "Update", [
      { Title: "OK", Method: _updateMainScheduleAndDoc },
      { Title: "CANCEL", Method: () => props.onHide() },
    ]);
  };
  const ShiftEvents = () => {
    setMode("shift_events");
    //Common.LuxonDateFromJSDate(event.Start)
    setParamDate(DateTime.fromISO(event.Start, { zone: "utc" }));
    setMoveEventsShow(true);
  };

  const MoveEventsCallback = () => {
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  };

  const _updateMainScheduleAndDoc = () => {
    if (ScheduleName !== "Main") window.guide_obj.schedule.copySchedule(ScheduleName, "Main");
    const html = window.guide_obj.createHTMLItinerary(ScheduleName, GuideSettings.itinerary);
    //window.guide_obj.document = html;
    //dispatch(slice1Actions.setGuide({ guide: null }));

    window.guide_obj.document = html;

    dispatch(slice1Actions.clearHTMLStack());
    //dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: html }));
    props.onHide();
  };

  if (ShowEventEdit)
    return (
      <EventEdit
        show={ShowEventEdit}
        onHide={() => setShowEventEdit(false)}
        event={event}
        mode={EventEditMode}
        place={null}
        where={EventEditWhere}
        schedule_name={ScheduleName}
        callback={() => EventEditCallback()}
      />
    );
  else if (HTMLReaderShow)
    return (
      <HTMLReader
        html={HTMLReaderContent}
        show={HTMLReaderShow}
        title="Event Details"
        onHide={() => {
          setHTMLReaderShow(false);
          props.onHide();
        }}
      />
    );
  else {
    const eventSubject = event?.Subject || "Event";
    const eventDate = event?.Start
      ? DateTime.fromISO(event.Start, { zone: "utc" }).toFormat("LLL d, yyyy")
      : null;
    const hasPlaces = eventContainsPlaces();
    let idx = 0;

    const Item = ({ label, onClick, icon: itemIcon, info, danger, highlight, videoKey }) => (
      <div className={`em-item${danger ? " danger" : ""}${highlight ? " highlight" : ""}`} style={{ "--i": idx++ }} onClick={onClick}>
        <div className="em-item-icon"><FontAwesomeIcon icon={itemIcon} /></div>
        <span className="em-item-label">{label}</span>
        {info && (
          <button
            className="em-item-info"
            onClick={(e) => { e.stopPropagation(); myAlert(info, "Info", null, videoKey); }}
            aria-label={`Info: ${label}`}
          >
            <FontAwesomeIcon icon={solid("info")} />
          </button>
        )}
      </div>
    );

    // Same gap/fix as PlaceModal.js's identical comment: this menu's items
    // are ad-hoc inline JSX conditionals, not a buildMenuList(advancedMode)
    // array, so gating "Combine Events"/"Swap or Replace Event"/"Delete
    // Event" behind advancedMode never got the usual "N more options"
    // discovery hint other menus have. Found 2026-10-05.
    const hiddenAdvancedCount = GuideEditMode && !advancedMode ? 3 : 0;

    return (
      <div className="modal">
        <Modal
          {...props}
          dialogClassName="myModalClass em-dialog"
          aria-labelledby="contained-modal-title-vcenter"
          animation={false}
          scrollable={false}
          centered
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="em-shell">
              <div className="em-header">
                <div className="em-header-icon" onClick={() => setScheduleModal(true)}>
                  <FontAwesomeIcon icon={solid("calendar-alt")} />
                </div>
                <div className="em-header-text">
                  <p className="em-title">{eventSubject}</p>
                  {eventDate && <span className="em-subtitle">{eventDate}</span>}
                </div>
                <button className="em-close" onClick={props.onHide}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>
              <div className="em-list">
                <span className="em-section-label">View</span>
                {hasPlaces && (
                  <Item
                    label="Center in Map"
                    icon={solid("crosshairs")}
                    onClick={handleShowOnMap}
                    info="Centers the places from the event on the map"
                  />
                )}
                {hasPlaces && (
                  <Item
                    label="Filter Places in Event"
                    icon={solid("filter")}
                    onClick={FilterPlaces}
                    info="Filters to show only the places from the event"
                  />
                )}
                <Item
                  label="Show Details"
                  icon={solid("file-lines")}
                  onClick={handleShowDetails}
                  info="Show the event details in document format"
                />
                {GuideEditMode && <div className="em-separator" />}
                {GuideEditMode && <span className="em-section-label">Edit</span>}
                {GuideEditMode && (
                  <Item
                    label="Shift Events"
                    icon={solid("arrows-left-right")}
                    onClick={ShiftEvents}
                    videoKey="move-events"
                    info="Shift this and subsequent events"
                  />
                )}
                {GuideEditMode && (
                  <Item
                    label="Edit Event"
                    icon={solid("pen")}
                    onClick={handleEditEvent}
                    info="Edit the event details i.e. subject, times, info and places"
                  />
                )}
                {GuideEditMode && (
                  <Item
                    label="Adjust Duration"
                    icon={solid("hourglass-half")}
                    onClick={handleAdjustDuration}
                    info="Change how long this event takes, and optionally recalculate the day or trip around it"
                  />
                )}
                {GuideEditMode && (
                  <Item
                    label="Add Event After"
                    icon={solid("calendar-plus")}
                    onClick={handleAddEventA}
                    info="Add a new event after this event"
                  />
                )}
                {GuideEditMode && (
                  <Item
                    label="Add Event Before"
                    icon={solid("calendar-plus")}
                    onClick={handleAddEventB}
                    info="Add a new event before this event"
                  />
                )}
                {/* "Combine Events" hidden 2026-10-19: rarely needed and never in
                    the app — same on both. Restore by removing `false &&`. */}
                {false && GuideEditMode && advancedMode && (
                  <Item
                    label="Combine Events"
                    icon={solid("object-group")}
                    onClick={combineEvents}
                    info="Combine places and info from multiple events"
                  />
                )}
                {GuideEditMode && advancedMode && (
                  <Item
                    label="Swap or Replace Event"
                    icon={solid("right-left")}
                    onClick={handleSwapEvent}
                    info="Trade this event's start and end time with another event in the schedule, or replace its place with one that's in the guide but not yet used in any schedule"
                    videoKey="swap-or-replace-events"
                  />
                )}
                {GuideEditMode && advancedMode && <div className="em-separator" />}
                {GuideEditMode && advancedMode && (
                  <Item
                    label="Delete Event"
                    icon={solid("trash")}
                    onClick={handleDeleteEvent}
                    info="Delete the event from the schedule. Note you cannot recover it."
                    danger
                  />
                )}
                {hiddenAdvancedCount > 0 && (
                  <Item
                    label={`${hiddenAdvancedCount} more option${hiddenAdvancedCount === 1 ? "" : "s"} in Advanced Mode`}
                    icon={solid("wand-magic-sparkles")}
                    onClick={() => window.dispatchEvent(new CustomEvent("toggleAdvancedMode"))}
                    highlight
                    info="Turn on Advanced Mode in Settings to see these options."
                  />
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <ScheduleModal show={scheduleModal} onHide={() => setScheduleModal(false)} />
        {MoveEventsShow && (
          <MoveEvents
            show={MoveEventsShow}
            onHide={() => setMoveEventsShow(false)}
            ScheduleName={ScheduleName}
            ScheduleNames={ScheduleNames}
            mode={Mode}
            param_date={ParamDate}
            anchorEventId={Mode === "shift_events" ? event?.ID : undefined}
            callback={MoveEventsCallback}
          />
        )}
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
          videoKey={AlertModalVideoKey}
        />
        {AdjustDurationShow && (
          <AdjustDurationDialog
            show={AdjustDurationShow}
            onHide={() => setAdjustDurationShow(false)}
            onConfirm={confirmAdjustDuration}
            initialMinutes={
              event?.Start && event?.End
                ? DateTime.fromISO(event.End, { zone: "utc" }).diff(
                    DateTime.fromISO(event.Start, { zone: "utc" }), "minutes"
                  ).minutes
                : 60
            }
          />
        )}
      </div>
    );
  }
};

export default EventModal;
